import React from 'react';
import { LoaderIcon, ClockIcon } from 'lucide-react';
import { Lead } from '../types/leads';
interface PendingVerificationProps {
  leads: Lead[];
  onUndo: (id: string) => void;
}
export function PendingVerification({
  leads,
  onUndo
}: PendingVerificationProps) {
  if (leads.length === 0) return null;
  const formatTime = (isoString?: string) => {
    if (!isoString) return '';
    return new Date(isoString).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };
  return <div className="bg-white rounded-xl shadow-sm border border-blue-200 overflow-hidden" data-id="element-152">
      {/* Header */}
      <div className="px-6 py-4 bg-blue-50 border-b border-blue-100" data-id="element-153">
        <div className="flex items-center justify-between" data-id="element-154">
          <div className="flex items-center" data-id="element-155">
            <div className="relative mr-3" data-id="element-156">
              <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-157">
                <LoaderIcon className="h-4 w-4 text-blue-600 animate-spin" data-id="element-158" />
              </div>
              <span className="absolute -top-0.5 -right-0.5 flex h-3 w-3" data-id="element-159">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" data-id="element-160"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500" data-id="element-161"></span>
              </span>
            </div>
            <div data-id="element-162">
              <h2 className="text-lg font-semibold text-blue-900" data-id="element-163">
                Awaiting Verification
              </h2>
              <p className="text-xs text-blue-600" data-id="element-164">
                Waiting for external system to confirm list placement
              </p>
            </div>
          </div>
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 tabular-nums" data-id="element-165">
            {leads.length} pending
          </span>
        </div>
      </div>

      {/* Lead Cards */}
      <div className="p-4" data-id="element-166">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-167">
          {leads.map(lead => <div key={lead.id} className="relative bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-lg p-4 overflow-hidden" data-id="element-168">
              {/* Animated progress bar at top */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-blue-100 overflow-hidden" data-id="element-169">
                <div className="h-full bg-blue-500 rounded-full animate-pulse" style={{
              width: '60%'
            }} data-id="element-170"></div>
              </div>

              <div className="flex items-start justify-between mt-1" data-id="element-171">
                <div className="flex-1 min-w-0" data-id="element-172">
                  <p className="text-sm font-medium text-gray-900 truncate" data-id="element-173">
                    {lead.name}
                  </p>
                  <p className="text-xs text-gray-500 truncate mt-0.5" data-id="element-174">
                    {lead.email}
                  </p>
                </div>
                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700" data-id="element-175">
                  <LoaderIcon className="h-3 w-3 mr-1 animate-spin" data-id="element-176" />
                  Verifying
                </span>
              </div>

              <div className="mt-3 flex items-center justify-between" data-id="element-177">
                <div className="flex flex-col" data-id="element-178">
                  <div className="flex items-center text-xs text-gray-500" data-id="element-179">
                    <span className="font-medium text-gray-700" data-id="element-180">
                      {lead.leadSource}
                    </span>
                    <span className="mx-1.5 text-gray-300" data-id="element-181">→</span>
                    <span className="truncate max-w-[100px]" data-id="element-182">
                      {lead.expectedDialingList}
                    </span>
                  </div>
                  <div className="flex items-center text-xs text-gray-400 mt-1" data-id="element-183">
                    <ClockIcon className="h-3 w-3 mr-1" data-id="element-184" />
                    Pushed at {formatTime(lead.resolvedAt)}
                  </div>
                </div>
                <button onClick={() => onUndo(lead.id)} className="text-xs text-gray-400 hover:text-red-500 transition-colors font-medium" data-id="element-185">
                  Cancel
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}